var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessesTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15V7.5H1.5V15H10.5ZM10.5 6C10.8978 6 11.2794 6.15804 11.5607 6.43934C11.842 6.72064 12 7.10218 12 7.5V15C12 15.3978 11.842 15.7794 11.5607 16.0607C11.2794 16.342 10.8978 16.5 10.5 16.5H1.5C0.6675 16.5 0 15.825 0 15V7.5C0 7.10218 0.158035 6.72064 0.43934 6.43934C0.720644 6.15804 1.10218 6 1.5 6H8.25V4.5C8.25 3.90326 8.01295 3.33097 7.59099 2.90901C7.16903 2.48705 6.59674 2.25 6 2.25C5.40326 2.25 4.83097 2.48705 4.40901 2.90901C3.98705 3.33097 3.75 3.90326 3.75 4.5H2.25C2.25 3.50544 2.64509 2.55161 3.34835 1.84835C4.05161 1.14509 5.00544 0.75 6 0.75C6.49246 0.75 6.98009 0.846997 7.43506 1.03545C7.89003 1.22391 8.30343 1.50013 8.65165 1.84835C8.99987 2.19657 9.27609 2.60997 9.46455 3.06494C9.653 3.51991 9.75 4.00754 9.75 4.5V6H10.5ZM6 12.75C5.60218 12.75 5.22064 12.592 4.93934 12.3107C4.65804 12.0294 4.5 11.6478 4.5 11.25C4.5 10.8522 4.65804 10.4706 4.93934 10.1893C5.22064 9.90804 5.60218 9.75 6 9.75C6.39782 9.75 6.77936 9.90804 7.06066 10.1893C7.34196 10.4706 7.5 10.8522 7.5 11.25C7.5 11.6478 7.34196 12.0294 7.06066 12.3107C6.77936 12.592 6.39782 12.75 6 12.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessesTab);
export default __webpack_public_path__ + "static/media/accessesTab.bf027aab.svg";
export { ForwardRef as ReactComponent };